<template><article><h1>刻度标记</h1>
<h3 id="当-marks-为-true"><a class="header-anchor" href="#当-marks-为-true" aria-hidden="true">#</a> 当 <code v-pre>marks</code> 为 <code v-pre>true</code></h3>
<p><example :value="example1"></example></p>
<h3 id="当-marks-的类型为-object"><a class="header-anchor" href="#当-marks-的类型为-object" aria-hidden="true">#</a> 当 <code v-pre>marks</code> 的类型为 <code v-pre>Object</code></h3>
<p><example :value="example2"></example></p>
<h3 id="当-marks-的类型为-array"><a class="header-anchor" href="#当-marks-的类型为-array" aria-hidden="true">#</a> 当 <code v-pre>marks</code> 的类型为 <code v-pre>Array</code></h3>
<p><example :value="example3"></example></p>
<h3 id="当-marks-的类型为-function"><a class="header-anchor" href="#当-marks-的类型为-function" aria-hidden="true">#</a> 当 <code v-pre>marks</code> 的类型为 <code v-pre>Function</code></h3>
<p><example :value="example4"></example></p>
<h3 id="配合-included-使用"><a class="header-anchor" href="#配合-included-使用" aria-hidden="true">#</a> 配合 <code v-pre>included</code> 使用</h3>
<p><example :value="example5"></example></p>
<h3 id="使用-hidelabel-隐藏-label"><a class="header-anchor" href="#使用-hidelabel-隐藏-label" aria-hidden="true">#</a> 使用 <code v-pre>hideLabel</code> 隐藏 label</h3>
<p><example :value="example6"></example></p>
</article></template>

<script>
  import examples from '@/examples/marks.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>